export default {
    PHONE_NUMBER: '(214) 423-3063',
    SUPPORT_EMAIL: "support@djplanningcenter.com",
    INFO_EMAIL: "info@djplanningcenter.com"
  }